import { CampaignRequest } from '../../api-models';
import BaseAdapter from './baseAdapter';
import { HTTPMethod, Channel } from '../../types/enums';
import { snakeCase } from '../../utils/formatters';
import { AdapterInterface } from '../../types/global';
import { CampaignSelection } from '../../types/campaigns.type';
import adaptFilterRequest from './adaptFilterRequest';
import { SelectedFilters } from '../../types/filters.type';
/**
 * Adapter for handling PII data for eligible households.
 * @description This class manages the secure transmission of PII data for campaign eligible households.
 * @security Ensures proper formatting and handling of sensitive PII data.
 */
export default class PostEligibleHouseholdsPii extends BaseAdapter<number> implements AdapterInterface {
  rawResponse: number;

  modifiedRequest: CampaignRequest;

  async adaptResponse(request: { campaignDetails: CampaignSelection, selectedFilters: SelectedFilters }): Promise<number> {
    const formattedRequest = this.adaptRequest(request);
    await this.fetchApiResponse('/api/eligible-households-with-pii', HTTPMethod.Post, formattedRequest);
    return this.rawResponse;
  }

  adaptRequest(request: { campaignDetails: CampaignSelection, selectedFilters: SelectedFilters }): CampaignRequest {
    if (!request.campaignDetails.campaignName || !request.campaignDetails.campaignType || !request.campaignDetails.communicationChannel) {
      throw new Error('Missing required fields');
    }
    const adaptedFilters = adaptFilterRequest(request.selectedFilters);
    this.modifiedRequest = {
      campaign_name: request.campaignDetails.campaignName,
      benefit_name: snakeCase(request.campaignDetails.campaignType),
      snapshot: request.campaignDetails.snapshot,
      channel_name: request.campaignDetails.communicationChannel === Channel.Letter
        ? Channel.BackendLetter
        : request.campaignDetails.communicationChannel.toLowerCase(),
      stagger: request.campaignDetails.stagger,
      dispatch_date: request.campaignDetails.dispatchDate,
      filter_request_list: adaptedFilters.filter_request_list,
      dynamic_filter_request_list: adaptedFilters.dynamic_filter_request_list,
    };
    return this.modifiedRequest;
  }
}
